(function () {

    if (window.WeirenJSBridge) { //已经存在时，不重复创建
        return;
    }

    var messagingIframe; //消息传输iframe
    var sendMessageQueue = []; //存储JS发送给Native的消息
    var messageHandlers = {};

    var CUSTOM_PROTOCOL_SCHEME = 'weirenscheme';
    var QUEUE_HAS_MESSAGE = '__WR_QUEUE_MESSAGE__';

    var responseCallbacks = {}; //响应回调的结果
    var uniqueId = 1;

    /**
     * 注册处理器（此方法供JS调用，只有注册了处理器才能供native调用）
     *
     * @param  {string} JS功能名称
     * @param  {function}
     * @return {void}
     */
    function registerHandler(handlerName, handler) {
        messageHandlers[handlerName] = handler;
    }

    /**
     * 调用处理器（此方法供JS调用native）
     * 注意：此方法只有在Native ready后才能调用，否则会没有响应
     *
     * @param  {string} native功能名称
     * @param  {object}
     * @param  {function}
     * @return {void}
     */
    function callHandler(handlerName, data, responseCallback) {

        if (arguments.length == 2 && typeof data == 'function') { //没有参数的情况
            responseCallback = data;
            data = null;
        }

        _doSend({
            handlerName: handlerName,
            data: data
        }, responseCallback);
    }

    /**
     * 处理消息，将消息放入消息队列，并通知native处理消息
     * @param  {object}
     * @param  {function}
     * @return {void}
     */
    function _doSend(message, responseCallback) {

        if (responseCallback) { //是否需要响应
            //响应ID
            var callbackId = 'cb_' + (uniqueId++) + '_' + new Date().getTime();
            responseCallbacks[callbackId] = responseCallback;
            message.callbackId = callbackId;
        }

        sendMessageQueue.push(message); //将消息放入消息队列
        messagingIframe.src = CUSTOM_PROTOCOL_SCHEME + '://' + QUEUE_HAS_MESSAGE; //通知Native处理消息
    }

    /**
     * 供native调用，Native调用此方法获取待处理消息
     *
     * @return {void/string}
     */
    function _fetchQueue(isReturn) {
        //待处理消息转成JSON
        var messageQueueString = JSON.stringify(sendMessageQueue);
        sendMessageQueue = [];
        if (isReturn) {
            return messageQueueString;
        }
        messagingIframe.src = CUSTOM_PROTOCOL_SCHEME + '://return/_fetchQueue/' + encodeURIComponent(
            messageQueueString);
    }

    /**
     * 分发处理native消息，jS内部调用
     *
     * @param  {object}
     * @return {void}
     */
    function _dispatchMessageFromNative(messageJSON) {

        setTimeout(_doDispatchMessageFromNative); //变成异步调用

        function _doDispatchMessageFromNative() {

            var message = JSON.parse(messageJSON);
            var responseCallback;

            if (message.responseId) { //JS调用Native后，Native发送过来的回调处理

                responseCallback = responseCallbacks[message.responseId];
                if (!responseCallback) {
                    return;
                }
                responseCallback(message.responseData);
                delete responseCallbacks[message.responseId];

            } else { //Native发送过来的消息，调用JS

                if (message.callbackId) { //消息是否需要回调Block

                    var callbackResponseId = message.callbackId;
                    //将结果发送给Native
                    responseCallback = function (responseData) {
                        _doSend({
                            responseId: callbackResponseId,
                            responseData: responseData
                        });
                    };
                }

                if (!message.handlerName) {
                    console.log("RTWebViewJSBridge: WARNING: no handlerName for message from native:", message);
                    return;
                }

                //所有注册过的方法
                var handler = messageHandlers[message.handlerName];
                if (!handler) {
                    console.log("RTWebViewJSBridge: WARNING: no handler for message from native:", message);
                    return;
                }
                //调用js函数
                handler(message.data, responseCallback);
            }
        }

    }

    /**
     * 供native调用，用来native与JS交互
     *
     * @param  {string}
     * @return {void}
     */
    function _handleMessageFromNative(messageJSON) {
        console.log("WeirenJSBridge: native message:" + messageJSON);
        _dispatchMessageFromNative(messageJSON);
    }

    window.WeirenJSBridge = {
        registerHandler: registerHandler,
        callHandler: callHandler,
        _fetchQueue: _fetchQueue,
        _handleMessageFromNative: _handleMessageFromNative
    };

    //创建消息队列iframe，用来向native发送消息
    function _createMessageQueueIframe() {
        messagingIframe = document.createElement('iframe');
        messagingIframe.style.display = 'none';
        document.documentElement.appendChild(messagingIframe);
    }

    _createMessageQueueIframe();

})();


(function () {

    if (!window.WeirenJSBridge) { //需要桥接对象
        console.info('没有桥接对象')
        return;
    }

    /**
     callName: 函数名
     params: 参数
     option: 回调函数

     */
    function _innerCallHandler(callName, params, option) {
        //调用者
        window.WeirenJSBridge.callHandler(callName, params, function (response) {

            if (response.code === 1) {
                if (option.success) {
                    option.success(response.data);
                }
            } else if (response.code === 0) {
                if (option.cancel) {
                    option.cancel();
                }
            } else {
                if (option.error) {
                    option.error(response);
                }
            }

        });
    }

    function getUserInfo(option) { //获取用户信息
        console.info('getUserInfo')
        option = option || {}; //表示option为undefined为赋值为{}

        //设置参数
        var params = {
            isAutoLogin: option.isAutoLogin == undefined ? 1 : option.isAutoLogin
        };

        //调用函数处理
        _innerCallHandler('getUserInfo', params, option);
    }

    function pickFile(option) { //选择文件

        option = option || {}; //

        //设置参数
        var params = {
            fileType: option.fileType || 10,
            fileMaxSize: option.fileMaxSize || 20
        };

        //调用函数处理
        _innerCallHandler('pickFile', params, option);
    }

    function uploadFile(option) { //选择文件

        option = option || {}; //

        //设置参数 原封不动传到后台
        var params = {
            fileType: 'img', //img,doc,pdf 等等
            fileMaxSize: '-1', //kb
            fileMinSize: '-1', //kb
            secrecyLevel: '0',
            imgMaxWidth: '-1',
            imgMaxHeidht: '-1',
            imgMinWidth: '-1',
            imgMinHeight: '-1',
            checkFile: 1
        };

        //调用函数处理
        _innerCallHandler('uploadFile', {
            params: option.params || params
        }, option);
    }


    function forwardPage(option) {
        if (!getWeirenClientInfo()) {
            window.location.href = option.uri
            return;
        }

        option = option || {};

        if (!option.uri && !option.url) {
            console.warn("forwardPage uri is undefined");

            if (option.error) {
                option.error({
                    code: -2,
                    msg: 'parameter uri is required'
                });
            }
            return;
        }

        var params = {
            uri: option.uri || option.url,
            url: option.uri || option.url,
            title: option.title
        };

        _innerCallHandler('forwardPage', params, option);
    }

    function closePage(option) {
        _innerCallHandler('closePage', {}, option || {});
    }

    function openWebBrowser(url) {

        let option = {};

        if (!url) {

            console.warn("forwardPage uri is undefined");

            if (option.error) {
                option.error({
                    code: -2,
                    msg: 'parameter uri is required'
                });
            }
            return;
        }

        var params = {
            url: url
        };

        _innerCallHandler('openWebBrowser', params, option);
    }

    function getWeirenClientInfo() {
        var clientInfo = navigator.userAgent.match(/\/Weiren[a-zA-z0-9]*\//);
        if (clientInfo) {
            return clientInfo;
        }
        let index = navigator.userAgent.indexOf('Weiren');
        if (index >= 0) {
            return navigator.userAgent.substring(index);
        }
        return ''
    }

    window.WeirenApi = {
        pickFile: pickFile,
        uploadFile: uploadFile,
        getUserInfo: getUserInfo,
        forwardPage: forwardPage,
        getWeirenClientInfo: getWeirenClientInfo,
        openWebBrowser: openWebBrowser,
        closePage: closePage,

        reloadPage() {
            let href = window.location.href;
            href += (href.indexOf('?') > -1 ? '&' : '?') + `_t=${(Math.random() + '').replace('.', '')}`
            window.location.replace(href);
        }
    };

})();

console.info(`window.clientInfo==> ${window.WeirenApi.getWeirenClientInfo()}`)
console.info(`window.WeirenApi==> ${window.WeirenApi}`)
console.info(`window.WeirenJSBridge==> ${window.WeirenJSBridge}`)

const nativeApi = window.WeirenApi;
export default nativeApi
